import { TUpdateWorkspacePayload, TWorkspaceSettings } from "@/types";

import API from "./api";

/** A workspace's identity: name, description, logo (members: MembersService). */
class WorkspaceClass {
	get = (id: number): Promise<TWorkspaceSettings> =>
		API.get(`workspaces/${id}`).then((res) => res.data);

	update = (
		id: number,
		payload: TUpdateWorkspacePayload
	): Promise<TWorkspaceSettings> =>
		API.patch(`workspaces/${id}`, payload).then((res) => res.data);

	updateLogo = (id: number, file: File): Promise<TWorkspaceSettings> => {
		const formData = new FormData();
		formData.append("logo", file);

		return API.post(`workspaces/${id}/logo`, formData, {
			headers: { "Content-Type": "multipart/form-data" },
		}).then((res) => res.data);
	};

	deleteLogo = (id: number): Promise<TWorkspaceSettings> =>
		API.delete(`workspaces/${id}/logo`).then((res) => res.data);
}

const WorkspaceService = new WorkspaceClass();

export default WorkspaceService;
